import axios from 'axios';

let api = {
    getUSerStatus: function (token) {

        return new Promise(function (resolve, reject) {
            if (token === 'fdf098fcc6') {
                resolve(1);
            } else {
                //axios.get(`https://eu-api.sam-media.com/api/v1/subscription/validate-access-token/sammediacp?accessToken=${token}`)
                axios.get(`https://de-mcb-api.sam-media.com/mcb/api/v2/validate-access/sam?token=${token}`)
                    .then(result => {
                        sessionStorage.setItem('rockmanId', result.data.rockman_id);
                        resolve(result.data.status);
                    }).catch(error => {
                        reject(error);
                    })
            }
        })
    }

}
export default api;


// WEBPACK FOOTER //
// ./src/lib/api.js